import ApiError from '_types/api/ApiError';
import tryCastAxiosError from '../axios/tryCastAxiosError';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (candidate: any): ApiError | undefined => {
    const axiosError = tryCastAxiosError<ApiError>(candidate);
    return axiosError.response?.data;
};
